import { TFeature } from '../../../types/map';
import { POINT_RADIUS, DOT_SIZE_SMALL, DOT_SIZE_BIG } from '../../../constants/map';

export enum FPointType {
  Regular = 1,
  ResidentialComplex = 2,
  Extended = 4,
  Viewed = 8,
}

export interface IPointConfig {
  radius: number;
  color: string;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  count?: string;
  hasContourShadow: boolean;
}

export interface IGetPointConfigParameters {
  feature: TFeature;
  isResidentialComplexesListing: boolean;
  isResultable: boolean;
  isDetailed: boolean;
}

const COLORS_CONFIG_MAP: { [key: number]: Pick<IPointConfig, 'color' | 'borderColor' | 'textColor'> } = {
  [FPointType.Regular]: { color: '#0468ff', borderColor: '#fff' },
  [FPointType.Regular | FPointType.Viewed]: { color: '#83b4ff', borderColor: '#fff' },
  [FPointType.ResidentialComplex]: { color: '#3ac500', borderColor: '#fff' },
  [FPointType.ResidentialComplex | FPointType.Viewed]: { color: '#97da7c', borderColor: '#fff' },
  [FPointType.Extended]: { color: '#fff', borderColor: '#0468ff', textColor: '#152242' },
  [FPointType.Extended | FPointType.Viewed]: { color: '#fff', borderColor: '#83b4ff', textColor: '#152242' },
};

export function getPointConfig({
  feature,
  isResidentialComplexesListing,
  isResultable,
  isDetailed,
}: IGetPointConfigParameters): IPointConfig {
  const pointType: number =
    feature.properties.isExtended && !feature.properties.isActive
      ? FPointType.Extended
      : (isResidentialComplexesListing || isDetailed) && feature.properties.hasNewobject
      ? FPointType.ResidentialComplex
      : FPointType.Regular;

  const colors =
    COLORS_CONFIG_MAP[
      pointType | (feature.properties.isViewed && !feature.properties.isActive ? FPointType.Viewed : 0)
    ];

  let borderWidth = 1;
  if (isResultable && !isDetailed) {
    borderWidth = 2;
  } else if (isDetailed) {
    if (feature.properties.isExtended && !feature.properties.isActive) {
      borderWidth = 2;
    } else {
      borderWidth = 0;
    }
  }

  let radius = POINT_RADIUS;
  if (feature.properties.isActive) {
    radius = 3;
  } else {
    if (isResultable && !isDetailed) {
      if (feature.properties.count === 1) {
        radius = DOT_SIZE_SMALL;
      } else if (feature.properties.count > 1) {
        radius = DOT_SIZE_BIG;
      }
    }

    if (!isResultable && feature.properties.isExtended) {
      radius -= 1;
    }
  }

  let count: string | undefined;
  if (isResultable && !isDetailed) {
    if (feature.properties.count > 1 && feature.properties.count <= 9) {
      count = String(feature.properties.count);
    } else if (feature.properties.count > 9) {
      count = '9+';
    }
  }

  return { ...colors, borderWidth, radius, count, hasContourShadow: isResultable && !isDetailed };
}
